import React from 'react'

import MinimalLayout from '@/components/layouts/MinimalLayout'
import Main from '@/components/misc/Main'
import { Card, CardContent } from '@/components/ui/card'
import useMinWidth from '@/hooks/useMinWidth'
import { cn } from '@/lib/utils'

interface Props {
  children: React.ReactNode
  variant?: 'card' | 'default'
}

const LandingGreyLayout: React.FC<Props> = ({ children, variant }) => {
  const isMinWidthSm = useMinWidth('sm')
  const isSmallDevice = !isMinWidthSm

  function render() {
    if (variant === 'card' && !isSmallDevice) {
      return (
        <div className="mt-6 w-full px-4">
          <div className="mx-auto flex flex-col items-center">
            <Card className="w-full max-w-150 p-0">
              <CardContent className="p-0">{children}</CardContent>
            </Card>
          </div>
        </div>
      )
    }

    return <div style={{ padding: '0 13px' }}>{children}</div>
  }

  return (
    <div className={cn({ 'bg-white': isSmallDevice })}>
      <MinimalLayout isDarkMode={false}>
        <Main>{render()}</Main>
      </MinimalLayout>
    </div>
  )
}

export default LandingGreyLayout
